<script>
export default {
    name: "PatientDischargeDetails",

    props: {

        patient: Object,
        showModal: Boolean,
        dischargeDetails: Object,
    },

    computed: {

        totalBedCharges() {
            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientWardCharges) return 0;

            if(!this.dischargeDetails.patientWardCharges.length) return 0;
            
            return this.dischargeDetails.patientWardCharges
                .map(wCharge => wCharge.amount ? parseFloat(wCharge.amount) : 0 )
                .reduce((sum, amt) => sum+amt);
        },

        totalDrugsAndServices() {

            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientDrugsnService) return 0;

            if(!this.dischargeDetails.patientDrugsnService.length) return 0;

            return this.dischargeDetails.patientDrugsnService
                .map(drugCharges => drugCharges.grandTotal ? parseFloat(drugCharges.grandTotal) : 0)
                .reduce((sum, amt) => sum+amt);
        },

        totalBill() {

            return this.totalDrugsAndServices + this.totalBedCharges;
        },

        totalDeposits() {
            if(!this.dischargeDetails) return 0;
            
            if(!this.dischargeDetails.patientsDeposits) return 0;

            if(!this.dischargeDetails.patientsDeposits.length) return 0;
            
            return this.dischargeDetails.patientsDeposits.map(dep => 
                dep.depositAmount ? parseFloat(dep.depositAmount) : 0)
                .reduce((sum, amt) => sum+amt);
        },

        totalPayments() {

            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientsPayments) return 0;

            if(!this.dischargeDetails.patientsPayments.length) return 0;

            return this.dischargeDetails.patientsPayments
                .map(payment => payment.receiptAmount ? parseFloat(payment.receiptAmount) : 0)
                .reduce((sum, amt) => sum+amt);
        },

        totalPaidAmt() {

            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientDrugsnService) return 0;

            if(!this.dischargeDetails.patientDrugsnService.length) return 0;

            return this.dischargeDetails.patientDrugsnService
                .map(drugCharges => drugCharges.paid ? parseFloat(drugCharges.paid) : 0)
                .reduce((sum, amt) => sum+amt);
        },

        totalBalance() {

            return this.totalBill - this.totalPaidAmt;
        },
    },

    methods: {

        printInterimBill() {

            window.open(`/reports/patients/interim-bill/print?patientID=${this.patient.patienT_ID}&visitNo=${this.patient.visitNo}`, '_blank', `ReportPrint`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },

}
</script>
<template>
<tail-modal :show="showModal" dimension="sm:w-11/12 md:w-1/2">
  <template v-slot:title>
    <h5 class="font-bold text-base">Interim Bill</h5>
  </template>
  <template v-slot:modal-body>
    <div class="flex md:flex-row sm:flex-col bg-blue-500  p-tiny text-white">
        <div class="flex-1 text-center">
            <h5 class="font-bold">Name: {{ patient.names }}</h5>
        </div>
        <div class="flex-1 text-center">
            <h5 class="font-bold">IP NO: {{ patient.ipfileno }}</h5>
        </div>
        <div class="flex-1 text-center">
            <h5 class="font-bold">Admitted On: {{ patient.dateAdmitted | dateFormat }}</h5>
        </div>
    </div>
    <div class="w-full p-tiny my-px">
        <h5 class="font-bold text-sm">Payment Mode: 
            <span class="text-blue-600">{{ patient.pmode }}</span></h5>
    </div>
    <div class="w-full p-1 text-center">
        <h5 class="font-bold text-base"> 
            <input type="checkbox" class="mr-2" v-if="patient.special" :value="true" v-model="patient.special">Inpatient Charges</h5>
    </div>
    <div class="w-full overflow-auto">
        <table class="table table-bordered table-hover">
            <thead class="bg-blue-500 text-sm text-white">
                <tr>
                    <th class="p-tiny">Ward</th>
                    <th class="p-tiny">Bed</th>
                    <th class="p-tiny">Bed Date In</th>
                    <th class="p-tiny">Bed Date Out</th>
                    <th class="p-tiny">Days</th>
                    <th class="p-tiny">Daily Charge</th>
                    <th class="p-tiny">Amount</th>
                </tr>
            </thead>
            <tfoot>
                <tr>
                    <th colspan="7" class="p-tiny text-right">Total: {{ totalBedCharges | numberFormat }}</th>
                </tr>
            </tfoot>
            <tbody class="text-xs bg-gray-100">
                <tr v-for="(wardCharge,idx) in dischargeDetails.patientWardCharges" :key="idx">
                    <td class="p-tiny">{{ wardCharge.ward }}</td>
                    <td class="p-tiny">{{ wardCharge.bed }}</td>
                    <td class="p-tiny">{{ wardCharge.bedDateIn | dateFormat }}</td>
                    <td class="p-tiny">{{ wardCharge.bedDateOut | dateFormat }}</td>
                    <td class="p-tiny">{{ wardCharge.days }}</td>
                    <td class="p-tiny">{{ wardCharge.daily_Charge | numberFormat }}</td>
                    <td class="p-tiny">{{ wardCharge.amount | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="w-full p-1 text-center">
        <h5 class="font-bold text-base">Drugs & Services</h5>
    </div>
    <div class="w-full overflow-auto">
        <table class="table table-bordered table-hover">
            <thead class="bg-blue-500 text-sm text-white">
                <tr>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Consultant</th>
                    <th class="p-tiny">Price</th>
                    <th class="p-tiny">Qty</th>
                    <th class="p-tiny">Total</th>
                    <th class="p-tiny">paid</th>
                    <th class="p-tiny">Balance</th>
                </tr>
            </thead>
            <tbody class="text-xs bg-gray-100">
                <tr v-for="(drugCharges, idx) in dischargeDetails.patientDrugsnService" :key="idx">
                    <td class="p-tiny">{{ drugCharges.txnDate | dateFormat }}</td>
                    <td class="p-tiny">{{ drugCharges.service }}</td>
                    <td class="p-tiny">{{ drugCharges.consultant }}</td>
                    <td class="p-tiny">{{ drugCharges.charge | numberFormat }}</td>
                    <td class="p-tiny">{{ drugCharges.quantity }}</td>
                    <td class="p-tiny">{{ drugCharges.grandTotal | numberFormat }}</td>
                    <td class="p-tiny">{{ drugCharges.paid | numberFormat }}</td>
                    <td class="p-tiny">{{ drugCharges.balance | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="w-full p-1 text-center">
        <h5 class="font-bold text-base">Deposits Received</h5>
    </div>
    <div class="w-full overflow-auto">
        <table class="table table-bordered table-hover">
            <thead class="bg-blue-500 text-sm text-white">
                <tr>
                    <th class="p-tiny">Trx Date</th>
                    <th class="p-tiny">Receipt No</th>
                    <th class="p-tiny">Type</th>
                    <th class="p-tiny">Mode</th>
                    <th class="p-tiny">Amount</th>
                    <th class="p-tiny">Allocated</th>
                    <th class="p-tiny">Un-allocated</th>
                </tr>
            </thead>
            <tbody class="text-xs bg-gray-100">
                <tr v-for="(patientDeposit, idx) in dischargeDetails.patientsDeposits" :key="idx">
                    <td class="p-tiny">{{ patientDeposit.trxDate | dateFormat }}</td>
                    <td class="p-tiny">{{ patientDeposit.receiptNo }}</td>
                    <td class="p-tiny">{{ patientDeposit.paymentType }}</td>
                    <td class="p-tiny">{{ patientDeposit.mode }}</td>
                    <td class="p-tiny">{{ patientDeposit.depositAmount | numberFormat }}</td>
                    <td class="p-tiny">{{ patientDeposit.amountAllocated | numberFormat }}</td>
                    <td class="p-tiny">{{ patientDeposit.unAllocatedAmount | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="w-full p-1 text-center">
        <h5 class="font-bold text-base">Payments Received</h5>
    </div>
    <div class="w-full overflow-auto">
        <table class="table table-bordered table-hover">
            <thead class="text-sm bg-blue-500 text-white">
                <tr>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">Receipt No</th>
                    <th class="p-tiny">Mode</th>
                    <th class="p-tiny">Paid Amount</th>
                    <th class="p-tiny">Credit Amt</th>
                    <th class="p-tiny">Receipt Amt</th>
                </tr>
            </thead>
            <tbody class="text-xs bg-gray-100">
                <tr v-for="(paymentReceived, idx) in dischargeDetails.patientsPayments" :key="idx">
                    <td class="p-tiny">{{ paymentReceived.date | dateFormat }}</td>
                    <td class="p-tiny">{{ paymentReceived.receipt_No }}</td>
                    <td class="p-tiny">{{ paymentReceived.mode }}</td>
                    <td class="p-tiny">{{ paymentReceived.amount | numberFormat }}</td>
                    <td class="p-tiny">{{ paymentReceived.creditAmount | numberFormat }}</td>
                    <td class="p-tiny">{{ paymentReceived.receiptAmount | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
        <div class="flex flex-col md:flex-row content-start p-1 bg-gray-300 my-2">
            <div class="flex-1">
                <h5 class="font-bold">Total Bill: {{ totalBill | numberFormat }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-bold">Payments Made: {{ totalPaidAmt | numberFormat }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-bold">Balance: {{ totalBalance | numberFormat }}</h5>
            </div>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button 
        class="btn-danger btn-sm text-xs rounded mr-6" 
        @click.prevent="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
    <button 
        class="btn-sm btn-info text-xs rounded" 
        @click.prevent="printInterimBill"><i class="fa fa-print"></i> Print</button>
  </template>
</tail-modal>
</template>